import React, { useEffect } from "react";
import { styled } from "styled-components";
import { Text } from "../../TextConstants";

const LocationSection = ({ location, marginTop="1rem" }) => {
  return (
    <ParkLabelValueWrapper marginTop={marginTop}>
      <ParkLabel>{Text.location}</ParkLabel>
      <ParkValue>
        <span>{location}</span>
      </ParkValue>
    </ParkLabelValueWrapper>
  );
};

const ParkLabel = styled.div`
  font-size: 1.25rem;
  font-weight: 700;
`;

const ParkValue = styled.div`
  font-size: 1rem;
  font-weight: 400;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const ParkLabelValueWrapper = styled.div`
  width: 100%;
  margin-top: ${(props) => props.marginTop};
`;

export default LocationSection;
